import { useEffect, useState } from 'react';

import { TileCarouselResult } from 'api/types/shared.types';
import { JobFunction } from 'utils/constants';

import { getRecommendedJobs } from './getRecommendedJobs';

type Props = {
  searchLocation: SearchLocation;
  options: {
    onlyWithLogo: boolean;
    jobFunction: JobFunction | null | undefined;
  };
};

export function useCarouselRecommendedJobs({
  searchLocation,
  options: { onlyWithLogo, jobFunction },
}: Props): TileCarouselResult[] {
  const [recommendedJobs, setRecommendedJobs] = useState<TileCarouselResult[]>(
    []
  );
  useEffect(() => {
    getRecommendedJobs({
      searchLocation,
      options: {
        onlyWithLogo,
        jobFunction,
      },
    }).then((jobs) => {
      setRecommendedJobs(
        jobs.map((job) => ({
          city: job.city,
          id: job.objectID,
          logo: job.logo,
          orgName: job.orgName,
          name: job.name,
          state: job.state,
          url: job.url,
        }))
      );
    });
  }, [searchLocation, onlyWithLogo, jobFunction]);
  return recommendedJobs;
}
